import React from "react";
import { useWorkShop } from "../../../../../contexts/workshop-context/WorkshopContext";
import "./styles.scss";
import logo from "../../../../../shared/resources/in-white-logo-only.png";
const PageHeader = () => {
  const workshop = useWorkShop();

  return (
    <div className="public-page-header-wrapper ">
      <div className="blue-line ">
        <div className="text-left title">
          <div className="header-text text-truncate">{workshop.title}</div>
        </div>
        <div className="image-logo">
          <img src={logo} alt="" />
        </div>
      </div>
      <div
        style={{
          padding: "20px",
          paddingLeft: "40px",
          paddingRight: "40px",
          textAlign: "justify",
        }}
      >
        <p
          className="small-scroll"
          style={{
            fontSize: "18px",
            color: "#777777",
            height: "110px",
            overflow: "auto",
            paddingRight: "10px",
          }}
        >
          {workshop.description}
        </p>
      </div>
    </div>
  );
};

export default PageHeader;
